module.exports = __webpack_public_path__ + "img/badge.0be2ac43.png";